import { hexToRgba } from 'styles/theme.js'

const themeStyles = colors => {
  const styles = {
    container: {
      border: 0,
      maxWidth: '100%',
      paddingBottom: 0,
      background: colors.whiteSmoke
    },
    content: {
      marginTop: 0
    },
    tileContainer: {
      height: '100%',
      background: 'none',
      overflow: 'hidden',
      padding: 0,
      borderWidth: 0,
      boxShadow: `0 3px 6px 0 ${hexToRgba(colors.white, 0.6)}`
    },
    quickActionBarContainer: {
      padding: '20px'
    },
    glanceContainer: {
      padding: '20px'

    },
    wellnessResourcesContainer: {
      padding: '20px',
      paddingBottom: 0,
      background: colors.unicornSilver
    },
    unavailableMessage: {
      unavailableMessage: {
        zIndex: 2,
        marginTop: 0,
        marginBottom: 0
      }
    }
  }
  return styles
}

export default themeStyles
